export const timeRanges = [
  {label: "Custom Time Range", value: "custom"},
  {label: "Past 15 minutes", value: "15m", windowPeriod: "1s"},
  {label: "Past 30 minutes", value: "30m", windowPeriod: "1s"},
  {label: "Past 1 hour", value: "1h", windowPeriod: "1m"},
  {label: "Past 3 hours", value: "3h", windowPeriod: "1m"},
  {label: "Past 6 hours", value: "6h", windowPeriod: "3m"},
  {label: "Past 12 hours", value: "12h", windowPeriod: "6m"},
  {label: "Past 1 day", value: "1d", windowPeriod: "1h"},
  {label: "Past 3 days", value: "3d", windowPeriod: "1h"},
  {label: "Past 1 week", value: "7d", windowPeriod: "3h"},
  {label: "Past 1 month", value: "30d", windowPeriod: "15h"},
  {label: "Past 2 months", value: "60d", windowPeriod: "30h"},
  {label: "Past 3 months", value: "90d", windowPeriod: "45h"},
];
